/**
 * Bài viết tin tức, đúng những gì API công khai trả về.
 *
 * Soạn ở backoffice, đọc qua /v1/public/news - front office không ghi gì cả.
 */
export interface NewsArticleInterface {
  id: string;
  title: string;
  slug: string;
  type: NewsTypeValue;
  category: string | null;
  /** Đường dẫn tương đối trên disk admin; qua getAssetFullUrl() mới ra URL đầy đủ. */
  image: string | null;
  author: string | null;
  excerpt: string | null;
  /** Chỉ có ở API chi tiết: danh sách không trả nội dung cho nhẹ. */
  content?: string | null;
  isFeatured: boolean;
  publishedAt: string | null;
  metaTitle?: string | null;
  metaDescription?: string | null;
}

/** Khối trên trang chủ mà bài thuộc về; khớp NewsArticle::TYPES bên backoffice. */
export type NewsTypeValue = "news" | "event";

export const NEWS_TYPE_NEWS: NewsTypeValue = "news";
export const NEWS_TYPE_EVENT: NewsTypeValue = "event";

export const NEWS_TYPE_LABELS: Record<NewsTypeValue, string> = {
  news: "Tin tức",
  event: "Sự kiện",
};

export interface NewsFilterInterface {
  page?: number;
  limit?: number;
  type?: NewsTypeValue;
  category?: string;
  featured?: boolean;
  keyword?: string;
}
